import React from 'react';
import ButtonUI from './ButtonUI';
import {
    Dialog, DialogActions, DialogContent,
    DialogContentText, withStyles, Typography,
    DialogTitle as MuiDialogTitle, IconButton,
    WithStyles, createStyles, Theme, Tooltip
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Paper, { PaperProps } from '@material-ui/core/Paper';
import {
    Check as CheckIcon
} from '@material-ui/icons';
import Draggable from 'react-draggable';
import useKeypress from '../../utils/useKeypress';

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

export const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} style={{ cursor: 'move' }} {...other}>
            {children ? <Typography variant="h6">{children}</Typography> : <span aria-hidden="true" style={{ display: 'block', width: 0, height: 0 }} />}
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} style={{ color: '#597dda' }}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}


type Props = {
    dialogTitle: string,
    dialogContentText: string,
    cancelTextButton: string,
    confirmTextButton: string,
    confirmDialogFunction: (row: any) => void,
    objectConfirmeDialogFuncion?: any,
    Button: JSX.Element,
}

const AlertDialog: React.FC<Props> = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = () => {
        if(open)
        {
            props.confirmDialogFunction(props.objectConfirmeDialogFuncion)
            handleClose()
        }
    }

    useKeypress('Enter', () => {
        if (open) {
            handleClick();
        }
    }, [open]);

    return (
        <React.Fragment>
            <Tooltip title={props.dialogTitle} onClick={handleClickOpen}>
                {props.Button}
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperComponent={PaperComponent}
            >
                <DialogTitle
                    id="draggable-dialog-title"
                    onClose={() => handleClose()}
                >
                    {props.dialogTitle}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.dialogContentText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                    <ButtonUI
                        variant="outlined"
                        onClick={handleClose}
                    >
                        {props.cancelTextButton}
                    </ButtonUI>

                    <ButtonUI
                        variant="contained"
                        color="primary"
                        type="submit"
                        startIcon={<CheckIcon />}
                        onClick={handleClick}
                    >
                        {props.confirmTextButton}
                    </ButtonUI>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default AlertDialog;